import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import {overwriteBillingAddress} from '../../../../../v2/actions/address-actions';
import FieldContainer2 from '../../../../../v2/form/FieldContainer2';
import FieldWrapper from '../../../../../v2/form/FieldWrapper/FieldWrapper';
import useStyles from './BillingAddressSelectionField.styles';
import Width from '../../../../../v2/style-helper/Width';

export function BillingAddressSelectionField(props) {
  const theme = useTheme();
  const classes = useStyles({theme, width: Width.full});
  const [limitedBillingAddress, setLimitedBillingAddress] = useState(true);
  const [billingAddress, setBillingAddress] = useState({});
  const savedAddressList = props.savedAddressesList;
  const savedAddressListAsArray = Object.values(savedAddressList);
  const addressOptions = savedAddressListAsArray.filter(savedAddress => savedAddress.selectedAddressCategory === 'STORED_RESIDENTIAL_ADDRESS');
  let newDefaultBillingAddress = addressOptions.findIndex(addressOption => addressOption.defaultBillingAddress);
  if (newDefaultBillingAddress === -1) {
    // eslint-disable-next-line prefer-destructuring
    newDefaultBillingAddress = 0;
  }
  const newDefaultBillingAddressId = addressOptions[newDefaultBillingAddress].addressId;
  const [item, setItem] = useState(addressOptions[newDefaultBillingAddress].addressee);
  
  useEffect(() => {
    setBillingAddress(addressOptions[newDefaultBillingAddress]);
    props.overwriteBillingAddress(addressOptions[newDefaultBillingAddress]);
  }, [billingAddress]);
  
  const limitedChecker = (address) => {
    if (limitedBillingAddress) {
      return address.addressNickname ? `${address.addressee}, ` : '';
    }
    return address.addressNickname ? `${address.addressNickname}, ${address.addressee}` : `${address.addressee}`;
  };

  const formatAddress = address => (
    `${limitedChecker(address)} ${address.nameNumber} ${address.streetName}, ${address.addressLine2},
    ${address.townCity}, ${address.county}, ${address.postCode}, ${address.countryName}`
  );
  
  const savedAddresses = addressOptions.map((address, index) => (
    <option key={index + 1} value={address.addressId} className={classes.options}>
      {formatAddress(address)}
    </option>
  ));
  
  const findAddress = (billingAddressId) => {
    let addressFromId = {};
    addressOptions.forEach((addressOption) => {
      if (addressOption.addressId === billingAddressId) {
        addressFromId = addressOption;
      }
    });
    return addressFromId;
  };
  
  const handleBillingAddressChange = (event) => {
    const newAddressSelected = findAddress(event.target.value);
    setItem(newAddressSelected.addressNickname ? `${newAddressSelected.addressNickname}` : `${newAddressSelected.addressee}`);
    props.overwriteBillingAddress(newAddressSelected);
    setBillingAddress(newAddressSelected);
    const fieldToBlur = document.getElementById('billingAddressSelectionFieldSelector');
    fieldToBlur.blur();
  };
  
  const handleSelectFocus = () => {
    setLimitedBillingAddress(false);
  };
  
  const handleSelectBlur = () => {
    setLimitedBillingAddress(true);
  };
  
  return (
    <FieldContainer2 id="billing-address-selection-field">
      {() => (
        <FieldWrapper>
          <div className={classes.billingAddressSelectionField}>
            <div className={classes.header}>
              {item}
            </div>
            <select
              id="billingAddressSelectionFieldSelector"
              data-test="billingAddressSelectionFieldSelector"
              defaultValue={Number(billingAddress.addressId || newDefaultBillingAddressId)}
              className={classes.billingSelectionField}
              onChange={handleBillingAddressChange}
              onBlur={handleSelectBlur}
              onFocus={handleSelectFocus}
            >
              {savedAddresses}
            </select>
          </div>
        </FieldWrapper>
      )}
    </FieldContainer2>
  );
}

const mapStateToProps = state => ({
  savedAddressesList: state.address.deliveryAddressList.addresses,
});

const mapDispatchToProps = {
  overwriteBillingAddress,
};

BillingAddressSelectionField.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  savedAddressesList: PropTypes.object,
  overwriteBillingAddress: PropTypes.func,
};

BillingAddressSelectionField.defaultProps = {
  savedAddressesList: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingAddressSelectionField);
